import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { trpc } from '@/lib/trpc';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { Layout } from './-components/layout';
import { PageSeo } from './-components/page-seo';
import { slugs } from './about-us.meta';
import { Hero } from './-components/about/hero';
import { Story } from './-components/about/story';
import { Microdonations } from './-components/about/microdonations';
import { Milestones } from './-components/about/milestones';
import { BCorp } from './-components/about/bcorp';
import { DeliveryHero } from './-components/about/delivery-hero';
import { Reports } from './-components/about/reports';

export const Route = createFileRoute('/www/about-us')({
	loader: ({ context }) => {
		// Warm the global stats behind the hero's funded-projects figure. `prefetchQuery`, not
		// `ensureQueryData` — see the homepage loader for why a floating rejected promise here takes the
		// server process down.
		context.queryClient.prefetchQuery(trpc.portal.getWorldcooGlobalStats.queryOptions());
	},
	component: Component,
});

function Component() {
	const { t } = useLingui();

	return (
		<Layout>
			<Header />
			<PageSeo
				slugs={slugs}
				title={t`About us - Worldcoo`}
				description={t`What if we could transform the world every time we use our card?`}
			/>
			<Hero />
			<Story />
			<Microdonations />
			<Milestones />
			<BCorp />
			<DeliveryHero />
			<Reports />
			<Footer />
		</Layout>
	);
}
